import { AuthError } from 'aws-amplify/auth';
import alert from './alert';
import { useTranslation } from 'react-i18next';

const handleAuthError = (error: AuthError, t: (key: string) => string) => {
  if (error.name === 'NotAuthorizedException' || error.name === 'InvalidPasswordException') {
    alert.error(t('Incorrect password. Please try again.'), {
      toastId: 'silent-auth-error',
    });
  } else if (error.name === 'LimitExceededException') {
    alert.error(t('Too many attempts. Please try again later.'), {
      toastId: 'silent-auth-error',
    });
  } else {
    alert.error(t('Unable to verify. Please check your code and try again!'), {
      toastId: 'silent-auth-error',
    });
  }
};

const handleGenericError = (error: any, t: (key: string) => string) => {
  let message = t('Something went wrong. Please try again.');

  if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === 'object' && error.errorMessage) {
    message = error.errorMessage;
  } else if (typeof error === 'object' && error.message) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }

  if (message === t('Invalid username or password.')) {
    message = t('Incorrect current password. Please try again.');
  }

  alert.error(t(message), { toastId: 'reset-password-error' });

  return error;
};

export const useErrorHandlers = () => {
  const { t } = useTranslation();

  return {
    handleAuthError: (error: AuthError) => handleAuthError(error, t),
    handleGenericError: (error: any) => handleGenericError(error, t),
  };
};
